<template>
	<v-card class="flex pa-0 background-2 round-card">
		<v-card-title class="pa-3">
			<p class="pl-2 pl-xl-3">{{ title }}</p><p class="entity-title">&nbsp;&nbsp;{{ entityTitle }}</p> &nbsp;&nbsp;<p class="fs12 grey--text"> {{ subTitle }}</p>
			<v-spacer></v-spacer>
			<v-tooltip v-if="!showTable" top>
				<template v-slot:activator="{ on }">				
					<v-btn  @click="showTable = !showTable" v-on="on" icon :style="listButtonStyle">
						<v-icon>storage</v-icon>
					</v-btn>
				</template>
				<span>Visualizza Tabella</span>
			</v-tooltip>						    
			<v-tooltip v-else top>
				<template v-slot:activator="{ on }">
					<v-btn  @click="showTable = !showTable" v-on="on" icon :style="listButtonStyle">
						<v-icon>equalizer</v-icon>
					</v-btn>
				</template>
				<span>Visualizza Grafico</span>
			</v-tooltip>					    
			<v-tooltip top v-if="showTable">
				<template v-slot:activator="{ on }">
					<v-btn @click="$eventBusUtility.exportCSV(headers, chartData, title)" v-on="on" icon>
						<v-icon>get_app</v-icon>
					</v-btn>
				</template>
				<span>Download</span>
			</v-tooltip>
		</v-card-title>
		<v-divider></v-divider>

		<v-container class="pt-4" fluid>
			<fields-generator
				class="pt-4"
				:fieldsset.sync="infoData"
				:model="model"
				ref="fieldsgenerator"
			></fields-generator>
			<v-row class="ma-0 px-2 pb-2">
				<v-col class="py-0" cols="6" sm="6" md="2" lg="2" v-if="!showTable">
					<v-switch 
						inset
						label="Mostra totali"
						color="primary"
						v-model="showTotal"
						hide-details
						class="margin-auto"
					></v-switch>
				</v-col>
			</v-row>

			<v-row v-if="showTable && loaded">
				<v-data-table
					class="background-2 w100p"
					:items="chartData"
					:headers="headers"
					:options.sync="pagination"
					:footer-props="{
						'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }]
					}">
					<template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
						<tr class="cursor-pointer">
							<td>
								{{ item['name'] }}
							</td>
							<td>
								{{ item['purchase_price'] | currency }}
							</td>
							<td>
								{{ item['amount_n'] | currency }}
							</td>
							<td>
								{{ item['n'] }}
							</td>
							<td>
								{{ item['amount_n_1'] | currency }}
							</td>
							<td>
								{{ item['n_1'] }}
							</td>
							<td class="text-center">
								<span v-if="item['amount_n'] > 0 && item['amount_n_1'] == 0" class="success--text">
									<v-icon color="success">trending_up</v-icon>                                            
								</span>                                        
								<span v-else-if="item['trend'] > 0" class="success--text">
									+ {{ item['trend']}} %
									<v-icon color="success">trending_up</v-icon>                                            
								</span>
								<span v-else-if="item['trend'] < 0" class="error--text">
										{{ item['trend']}} %
									<v-icon color="error">trending_down</v-icon>
								</span>
								<span v-else>
									<v-icon color="info">trending_flat</v-icon>                                            
								</span>
							</td>
						</tr>
					</template>
					<template v-slot:footer.page-text="{ pageStart, pageStop }">
						Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
					</template>
				</v-data-table>
			</v-row>

			<v-row v-else-if="!showTable && loaded" >
				<v-col cols="12">
					<stacked-columns-3d
						:chart-data="chartData"
						:chart-info="chartInfo"
						:chart-height="chartHeight"
						:show-total="showTotal"
					></stacked-columns-3d>
				</v-col>
				<v-col class="py-0" id="exportbutton" cols="6" sm="6" md="2" lg="2" ></v-col>
			</v-row>

			<v-row class="pt-2 pb-2"  justify="center">
				<v-col lg="2" md="3" sm="6">                            
					<v-list two-line class="background-2 w100p">
						<v-list-item>
							<v-list-item-action>
								<v-icon color="primary">mdi-currency-eur</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>Totale {{ typeTrans }} periodo A</v-list-item-title>
								<v-list-item-subtitle>{{ totalCostN | currency}}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>       
				</v-col>    
				<v-col lg="2" md="3" sm="6">                            
					<v-list two-line class="background-2 w100p">
						<v-list-item>
							<v-list-item-action>
								<v-icon color="primary">local_offer</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>Totale quantità A</v-list-item-title>
								<v-list-item-subtitle>{{ totalQuantityN }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-col>
				<v-col lg="2" md="3" sm="6">                            
					<v-list two-line class="background-2 w100p">
						<v-list-item>
							<v-list-item-action>
								<v-icon color="primary">mdi-currency-eur</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>Totale {{ typeTrans }} periodo B</v-list-item-title>
								<v-list-item-subtitle> {{ totalCostN_1 | currency }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-col>
				<v-col lg="2" md="3" sm="6">                            
					<v-list two-line class="background-2 w100p">
						<v-list-item>
							<v-list-item-action>
								<v-icon color="primary">local_offer</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>Totale quantità B</v-list-item-title>
								<v-list-item-subtitle>{{ totalQuantityN_1 }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>

	import StackedColumns3d from '@/components/common/StackedColumns3d'

	export default {
		name: 'sold-products',
		components: {
			StackedColumns3d
		},

		props: {
			modelId: Number,
			type: String,
            entityTitle: String,
			url: {
				type: String,
				default: 'soldproductsstats'
			},
			modelKey: {
				type: String,
				default: 'company_id'
			},
			title: {
				type: String,
				default: 'Prodotti Venduti'
			},
		},

		data() {
			return {
				fieldsset: {},
				model: {
					[this.modelKey]: this.modelId,
					type: this.type
				},
				loaded: false,
				chartData: [],
				chartInfo: {},
				infoData: {},
				chartHeight: 800,
				showTotal: false,
				showTable: true,
				listButtonStyle: '',
				datepicker_menu: {},
				headers: [],
				pagination: {},
				totalItems: 0,
			}
		},
			
		created() {

			this.axios.post(this.url + '-info', this.model).then(response => {
				// get body data
				this.infoData = response.data.info
				this.fieldsset = response.data.info.fields

				_.forEach(this.fieldsset, (value, key) => {
					if(value.default) {
						this.$set(this.model, value.key, value.default)
					}
				})
				this.headers = [
					{
						'text': 'Prodotto',
						'align': 'left',
						'sortable': true,
						'value': 'name',
					},
					{
						'text': 'Prezzo di Acquisto',
						'align': 'left',
						'sortable': true,
						'value': 'purchase_price',
					},
					{
						'text': this.typeTrans + ' Periodo A',
						'align': 'left',
						'sortable': true,
						'value': 'amount_n',
					},
					{
						'text': 'Quantità A',
						'align': 'left',
						'sortable': true,
						'value': 'n',
					},
					{
						'text': this.typeTrans + ' Periodo B',
						'align': 'left',
						'sortable': true,
						'value': 'amount_n_1',
					},
					{
						'text': 'Quantità B',
						'align': 'left',
						'sortable': true,
						'value': 'n_1',
					},
					{
						'text': 'Andamento B/A',
						'align': 'left',
						'sortable': true,
						'value': 'trend',
					}
				]
				this.loaded = true

			}, response => {
				// error callback
			})
		},


		watch: {
			model: {
				handler() {
					this.getData()
				},
				deep: true,
			},

			showTable: {
				handler(newVal, oldVal) {
					if(newVal) {
						this.listButtonStyle = ''
					} else this.listButtonStyle = 'margin-right: 54px !important;'
				}
			}

		},

		computed: {

			subTitle() {
				if(this.type === 'revenue') {
					return ' (Fatturato)'
				} else if('costs') {
					return ' (Costi)' 
				}
				return ''
			},

			typeTrans() {
				if(this.type === 'revenue') {
					return 'Fatturato'
				} else if('costs') {
					return 'Costo' 
				}
				return ''
			},

			totalCostN() {
				if(this.loaded)
					return this.chartData.reduce((acc, product) => acc + (product.amount_n ? parseFloat(product.amount_n) : 0), 0)
				return 0
			},

			totalCostN_1() {
				if(this.loaded)
					return this.chartData.reduce((acc, product) => acc + (product.amount_n_1 ? parseFloat(product.amount_n_1) : 0) , 0)
				return 0
			},

			totalQuantityN() {
				if(this.loaded)
					return (this.chartData.reduce((acc, product) => acc + (product.n ? product.n : 0), 0)).toFixed(2)
				return 0
			},

			totalQuantityN_1() {
				if(this.loaded)
					return (this.chartData.reduce((acc, product) => acc + (product.n_1 ? product.n_1 : 0), 0)).toFixed(2)
				
				return 0
			}
		},

		methods: {

			getData() {

				this.axios.post(this.url, this.model).then(response => {
					this.chartData.splice(0, this.chartData.length)
					this.totalItems = Object.keys(response.data.data.datasets).length
					_.forEach(response.data.data.datasets, (value, key) => {
						value.n = Math.round(value.n * 100) / 100
						value.n_1 = Math.round(value.n_1 * 100) / 100
						this.chartData.push(value)
					})
					if(response.data.data.datasets.length == 0) {
						this.chartData.push({n: 0, n_1: 0, name: ''})
						this.chartHeight = 500
					} else {
						this.chartHeight = 800
					}

					this.$set(this.chartInfo, 'n', 'Dal ' + moment(response.data.data.n.from).format('L') + ' al ' + moment(response.data.data.n.to).format('L'))
					this.$set(this.chartInfo, 'n_1', 'Dal ' + moment(response.data.data.n_1.from_old).format('L') + ' al ' + moment(response.data.data.n_1.to_old).format('L'))

					this.loaded = true

				}, response => {
					// error callback
				})
			},


		},
	}
</script>